import androidInterstitial from 'app/common/images/interstitial/android-icon-1x.png';
import iOSInterstitial from 'app/common/images/interstitial/ios-icon-1x.png';
import { createImageCSS } from 'app/common/react/components/growth/unauth/lib/ImageUtils';

const cssStyles = () => `
.TabletAppInterstitial__gridContainer {
  -webkit-mask-image: -webkit-radial-gradient(circle, #fff 100%, #000 100%);
  mask-image: radial-gradient(circle, #fff 100%, #000 100%);
}

.TabletInterstitial__headerContainer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.TabletInterstitial__largeCover {
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}


@media screen and (orientation: landscape) {
  .TabletAppInterstitial__gridContainer {
    display: inline-block;
    height: 75vh !important;
    width: 45%;
    vertical-align: top;
  }

  .TabletAppInterstitial__gridContainerLargeCover {
    display: inline-block;
    height: 60vh !important;
    width: 45%;
    vertical-align: top;
  }

  .TabletAppInterstitial__appInfo {
    display: inline-block;
    left: 50%;
    top: 50%;
    transform: translate(0%, -50%);
    width: 45%;
  }
}

.TabletAppInterstitial__iOSIcon {
  ${createImageCSS(iOSInterstitial, '55px', '55px')}
}

.TabletAppInterstitial__androidIcon {
  ${createImageCSS(androidInterstitial, '55px', '55px')}
}
`;

export default cssStyles;
